import React, {useContext, useEffect, useState} from 'react';
import {Button, ButtonGroup, Container, Grid, Tab, Tabs, Typography, Box, List, ListItem, useMediaQuery, Snackbar} from "@material-ui/core";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import scheduleImage from '../../assests/images/schedule.jpg'
import locImage from '../../assests/images/Vectorlocation.svg'
import timeVector from '../../assests/images/timeVector.svg'
import Vectortime from '../../assests/images/Vectorcalender.svg'
import PropTypes from 'prop-types';
import Divider from "@material-ui/core/Divider";
import moment from "moment";
import EventButton from "../components/EventButton";
import {HHMMFromMilliseconds} from "../../utils/date"
import {fetchStreamJson} from "../../utils/api"
import {JsonContext} from "../../Context";
import SimpleModal from "../components/Modal";
import {useHistory} from "react-router-dom";
import {Alert} from "@material-ui/lab";
import {getImage} from "../../utils/image";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{pt: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
    scheduleTabContainer: {
        backgroundColor: (theme) => theme.palette.background.default
    },
    tabs: {
        color: (theme) => theme.palette.text.primary,
    },
    scheduleContentContainer: {
        backgroundColor: (theme) => theme.palette.background.secondary,
        color: (theme) => theme.palette.text.primary,
        //opacity: 0.5,
        paddingBottom: '72px'
    },
    scheduleList: {
        padding: '40px 11px 40px 24px',
        backgroundColor: (theme) => theme.palette.background.primary,
        boxShadow: ' 0px 16px 32px -4px rgba(0, 0, 0, 0.12)',
        marginTop: '24px',
        [theme.breakpoints.down('xs')]: {
            display: 'block',
            marginTop: '20px',
            padding: '12px',
        },
    },
    span: {
      display: "inline-block",
      verticalAlign: 'middle',
    },
    scheduleImg: {
      display: "inline-block",
      verticalAlign: 'middle',
        width: '95px',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
          width: '100%',
      },
    },
    scheduleMainImg: {
        width: '100%'
    },
    title: {
        display: "inline-block",
        verticalAlign: 'middle',
        width: '330px',
        margin: '0 4%',
        [theme.breakpoints.down('lg')]: {
            fontSize: '14px',
            width: '250px'
        },
        [theme.breakpoints.down('md')]: {
            width: '100%'
        },
        [theme.breakpoints.down('md')]: {
            margin: '0',
            width: '100%',
            lineHeight: '18px'
        },
    },
    location: {
      display: "inline-block",
      verticalAlign: 'middle',
      width: '240px',
      margin: '0 4% 0 0',
      [theme.breakpoints.down('lg')]: {
        fontSize: '14px',
        width: '300px'
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        margin: '0 0 14px'
      },
    },
    date: {
        display: "inline-block",
        verticalAlign: 'middle',
        width: '95px',
        margin: '0 4% 0 0',
        lineHeight: '24px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px'
        },
        [theme.breakpoints.down('md')]: {
            width: '100%'
          },
        [theme.breakpoints.down('xs')]: {
            display: 'inline-block',
            width: 'auto',
            margin: '0 0 14px 30px',
            paddingTop: '14px',
        },
    },
    timing: {
        paddingTop: '24px',
        [theme.breakpoints.down('xs')]: {
            display: 'inline-block',
            paddingTop: '14px',
            paddingBottom: '14px'
        },
    },
    tabSection: {
        minWidth: 'auto',
        padding: '0 0 11px',
        marginRight: '40px'
    },
    scheduleText: {
        letterSpacing: '0.11px',
        paddingTop: '24px',
        opacity: '0.7',
        fontFamily: 'Manrope',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
            lineHeight: '24px',
            paddingTop: '20px'
        },
    },
    scheduleListWrapper: {
        marginLeft: "5%",
        fontFamily: 'Manrope',
        [theme.breakpoints.down('xs')]: {
            marginLeft: "0",
        },
    }

}));
export default function Schedule(props) {
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const theme = useTheme();
    let history = useHistory();
    const classes = useStyles(theme);
    const [tabValue, setTabValue] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [selectedSession, setSelectedSession] = useState(null);
    const [streamData, setStreamData] = useState({});
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const data = useContext(JsonContext).schedule;
    const toggleModal = (session)=>{
        !openModal ? setSelectedSession(session) : setSelectedSession(null)
        setOpenModal(!openModal);
    }
    useEffect(async ()=>{
        window.scrollTo({top:0});
        document.title = data.title;
        let streamObj = {};
        for (let i = 0; i < data.list.length; i++) {
            if(moment(data.list[i].date).format("ddd MMM D") == moment().format("ddd MMM D")){
                setTabValue(i)
            }
            for (let j = 0; j < data.list[i].sessions.length; j++) {
                const stream = data.list[i].sessions[j].stream;
                if (!(!!streamObj[stream])){
                    await fetchStreamJson(stream).then(data=>{
                        streamObj[stream] = data;
                    });
                }
            }
        }
        setStreamData(streamObj);
    },[])
    const onSubmit = (status=false) => {
        status ? history.push({
                    pathname: `/watch/${selectedSession.id}`,
                    state: {}
                }) : setOpenSnack(true)
        toggleModal();
    }

    const renderSessionList = (sessions)=>{
        let newSessionsObject = {};
        for (let i = 0; i < sessions.length; i++) {
            if(!newSessionsObject[sessions[i].startDate]){
                newSessionsObject[sessions[i].startDate]=[];
            }
            newSessionsObject[sessions[i].startDate].push(sessions[i])
        }
        return Object.keys(newSessionsObject).map((time, index)=>{
            return <>
                {!isSmallScreen && <Typography component='div' className={classes.timing} style={{fontFamily: 'Manrope'}}>{moment(time).format('LT')}</Typography>}
                {!isSmallScreen && <Divider light style={{marginTop: '4px'}}/>}
                <List component={'ul'} className={classes.scheduleListWrapper}>
                    {
                        newSessionsObject[time].map((session, index1)=>{
                            return <ListItem className={classes.scheduleList} key={`session_${session.id}`}>
                            <span className={classes.scheduleImg}>
                                <img src={getImage(session.image)} alt={session.image} className={classes.scheduleMainImg}/>
                            </span>
                                {!isSmallScreen ? <><Typography className={classes.title} component={'span'} variant={'subtitle1'}>
                                    {session.title}
                                </Typography>
                                <Typography className={classes.location} component={'span'} variant={'subtitle1'}>
                                    <img src={locImage} alt="" style={{marginRight: '16px'}} className={classes.span}/><span className={classes.span}  style={{width: '200px'}}>{session.location}</span>
                                </Typography>
                                <Typography className={classes.date} component={'span'} variant={'subtitle1'}>
                                    <img src={timeVector} alt="" style={{marginRight: '16px'}} className={classes.span}/>{HHMMFromMilliseconds(new Date(session.endDate) - new Date(session.startDate))}
                                </Typography>  </> : <>
                                <Typography className={classes.title} component={'span'} variant={'subtitle1'}>
                                    {session.title}
                                </Typography>
                                <Typography component='div' className={classes.timing}>
                                <img src={Vectortime} alt="" style={{marginRight: '16px'}} className={classes.span}/>
                                {moment(time).format('LT')}
                                </Typography>
                                <Typography className={classes.date} component={'span'} variant={'subtitle1'}>
                                    <img src={timeVector} alt="" style={{marginRight: '16px'}} className={classes.span}/>{HHMMFromMilliseconds(new Date(session.endDate) - new Date(session.startDate))}
                                </Typography>
                                <Typography className={classes.location} component={'span'} variant={'subtitle1'}>
                                    <img src={locImage} alt="" style={{marginRight: '16px'}} className={classes.span}/><span className={classes.span}  style={{width: '200px'}}>{session.location}</span>
                                </Typography></>}
                                <EventButton videoData={streamData[session.stream]} data={session} toggleModal={toggleModal}/>
                            </ListItem>
                        })
                    }
                </List>
            </>
        })

    }

    return <>
        <div className={classes.scheduleTabContainer}>
            <Container maxWidth={'lg'}>
                <Typography component={'h2'} variant={'h2'} style={{marginBottom: '29px'}}>
                    Schedule
                </Typography>
                <Tabs value={tabValue} onChange={handleChange} className={classes.tabs} variant="scrollable" aria-label="basic tabs example">
                    {
                        data.list.map((item)=>{
                            return <Tab label={moment(item.date).format("ddd MMM D")} className={classes.tabSection}/>
                        })
                    }
                </Tabs>
            </Container>
        </div>
        <div className={classes.scheduleContentContainer}>
            <Container maxWidth={'lg'}>
                <Typography component={'p'} className={classes.scheduleText}>
                    Select the event you have purchased a ticket for and enter the event code you received to watch the
                    livestream.
                </Typography>
                {
                    data.list.map((item, index)=>{
                        return <TabPanel key={`tabPanel_${index}`} value={tabValue} index={index} className={classes.tabListWrapper}>
                            {renderSessionList(item.sessions)}
                        </TabPanel>
                    })
                }
            </Container>
        </div>
        {openModal &&
            <SimpleModal sessionData={selectedSession} open={openModal} onClose={toggleModal} onSubmit={onSubmit}/>}
        <Snackbar open={openSnack} autoHideDuration={6000} onClose={()=>setOpenSnack(false)} anchorOrigin={{ vertical:'top', horizontal:'right' }}>
            <Alert onClose={()=>setOpenSnack(false)} severity="error" sx={{ width: '100%' }}>
                Enter correct email id and event code.
            </Alert>
        </Snackbar>
    </>
}